// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"92202461","453":"2dc86387","455":"74a88489","977":"b365f39b"}[chunkId] + ".chunk.js";
};